export namespace Permission {
  export enum Package {
    SALES_ADMIN = 'SALES_ADMIN',
    SALES_PLATFORM = 'SALES_PLATFORM',
  }

  export enum Profile {
    VIEW = 'Profile:View',
    UPDATE = 'Profile:Update',
    CHANGE_PASSWORD = 'Profile:Change Password',
    Logout = 'Profile:Logout',
  }

  export enum Logout {
    VIEW = 'Logout:View',
  }

  export enum AccessSecurity {
    VIEW = 'Access Security:View',
  }

  export namespace AccessSecurity {
    export enum Role {
      VIEW = 'Access Security:Role:View',
      ADD = 'Access Security:Role:Add',
      UPDATE = 'Access Security:Role:Update',
      DELETE = 'Access Security:Role:Delete',
    }

    export enum User {
      ADD = 'Access Security:User:Add',
      VIEW = 'Access Security:User:View',
      UPDATE = 'Access Security:User:Update',
      CHANGE_PASSWORD = 'Access Security:User:Change Password',
      SUSPEND_AND_UNSUSPEND = 'Access Security:User:Suspend and Unsuspend',
    }

    export enum PasswordPolicy {
      VIEW = 'Access Security:Password Policy:View',
      UPDATE = 'Access Security:Password Policy:Update',
    }
  }

  export enum AccountJournal {
    VIEW = 'Account Journal:View',
  }

  export namespace AccountJournal {
    export enum AccountMapping {
      VIEW = 'Account Journal:Account Mapping:View',
      UPDATE = 'Account Journal:Account Mapping:Update',
      COPY_FROM = 'Account Journal:Account Mapping:Copy From',
    }

    export enum GLExport {
      VIEW = 'Account Journal:GL Export:View',
      ADD = 'Account Journal:GL Export:Add',
      DOWNLOAD = 'Account Journal:GL Export:Download',
    }
  }

  export enum CommonSetting {
    VIEW = 'Common Setting:View',
  }

  export namespace CommonSetting {
    export enum CompanyListing {
      ACTIVE_AND_DEACTIVE = 'Common Setting:Company Listing:Active and Deactive',
      ADD = 'Common Setting:Company Listing:Add',
      UPDATE = 'Common Setting:Company Listing:Update',
      VIEW = 'Common Setting:Company Listing:View',
    }

    export namespace CompanyListing {
      export enum AccountReceivableAging {
        UPDATE = 'Company Listing:Account Receivable Aging:Update',
        VIEW = 'Company Listing:Account Receivable Aging:View',
      }

      export enum Bank {
        ADD = 'Company Listing:Bank:Add',
        DELETE = 'Company Listing:Bank:Delete',
        UPDATE = 'Company Listing:Bank:Update',
        VIEW = 'Company Listing:Bank:View',
      }

      export enum CompanyProfile {
        UPDATE = 'Company Listing:Company Profile:Update',
        VIEW = 'Company Listing:Company Profile:View',
      }

      export enum DocumentNumberingSettings {
        COPY_FORM = 'Company Listing:Document Numbering Settings:Copy Form',
        UPDATE = 'Company Listing:Document Numbering Settings:Update',
        VIEW = 'Company Listing:Document Numbering Settings:View',
      }

      export enum Township {
        ADD = 'Company Listing:Township:Add',
        DELETE = 'Company Listing:Township:Delete',
        UPDATE = 'Company Listing:Township:Update',
        VIEW = 'Company Listing:Township:View',
      }
    }

    export enum CurrencyExchangeRate {
      VIEW = 'Common Setting:Currency Exchange Rate:View',
      ACTIVE_AND_DEACTIVE = 'Common Setting:Currency Exchange Rate:Active and Deactive',
      ADD = 'Common Setting:Currency Exchange Rate:Add',
      UPDATE = 'Common Setting:Currency Exchange Rate:Update',
      DELETE = 'Common Setting:Currency Exchange Rate:Delete',
    }

    export enum Discount {
      VIEW = 'Common Setting:Discount:View',
      ADD = 'Common Setting:Discount:Add',
      UPDATE = 'Common Setting:Discount:Update',
      ACTIVE_AND_DEACTIVE = 'Common Setting:Discount:Active and Deactive',
      DELETE = 'Common Setting:Discount:Delete',
    }

    export enum DiscountType {
      DELETE = 'Common Setting:Discount Type:Delete',
      ADD = 'Common Setting:Discount Type:Add',
      UPDATE = 'Common Setting:Discount Type:Update',
      VIEW = 'Common Setting:Discount Type:View',
    }

    export enum EndFinancier {
      ACTIVE_AND_DEACTIVE = 'Common Setting:End Financier:Active and Deactive',
      ADD = 'Common Setting:End Financier:Add',
      MORTGAGE_PLAN = 'Common Setting:End Financier:Mortgage Plan',
      VIEW = 'Common Setting:End Financier:View',
      DELETE = 'Common Setting:End Financier:Delete',
    }

    export namespace EndFinancier {
      export enum MortgagePlan {
        VIEW = 'End Financier:Mortgage Plan End Financier:View',
        ADD = 'End Financier:Mortgage Plan End Financier:Add',
        ADD_NEW_PAYMENT_PLAN = 'End Financier:Mortgage Plan End Financier:Add New Payment Plan',
        UPDATE = 'End Financier:Mortgage Plan End Financier:Update',
        DELETE = 'End Financier:Mortgage Plan End Financier:Delete',
      }

      export namespace MortgagePlan {
        export enum PaymentPlan {
          UPDATE = 'Mortgage Plan End Financier:Payment Plan:Update',
          DELETE = 'Mortgage Plan End Financier:Payment Plan:Delete',
          ADD_RETENTION = 'Mortgage Plan End Financier:Payment Plan:Add Retention',
        }

        export namespace PaymentPlan {
          export enum Retention {
            UPDATE = 'Payment Plan:Retention:Update',
            DELETE = 'Payment Plan:Retention:Delete',
          }
        }
      }
    }

    export enum IndoTaxReportingSetup {
      VIEW = 'Common Setting:Indo Tax Reporting Setup:View',
    }

    export namespace IndoTaxReportingSetup {
      export enum TaxTransactionCode {
        VIEW = 'Indo Tax Reporting Setup:Tax Transaction Code:View',
        ADD = 'Indo Tax Reporting Setup:Tax Transaction Code:Add',
        UPDATE = 'Indo Tax Reporting Setup:Tax Transaction Code:Update',
        DELETE = 'Indo Tax Reporting Setup:Tax Transaction Code:Delete',
      }

      export namespace TaxTransactionCode {
        export enum AdditionalRemarks {
          VIEW = 'Tax Transaction Code:Additional Remarks:View',
          ADD = 'Tax Transaction Code:Additional Remarks:Add',
          UPDATE = 'Tax Transaction Code:Additional Remarks:Update',
          DELETE = 'Tax Transaction Code:Additional Remarks:Delete',
        }

        export enum FacilityCap {
          VIEW = 'Tax Transaction Code:Facility Cap:View',
          ADD = 'Tax Transaction Code:Facility Cap:Add',
          UPDATE = 'Tax Transaction Code:Facility Cap:Update',
          DELETE = 'Tax Transaction Code:Facility Cap:Delete',
        }
      }

      export enum PurchaserIDType {
        VIEW = 'Indo Tax Reporting Setup:Purchaser ID Type:View',
        ADD = 'Indo Tax Reporting Setup:Purchaser ID Type:Add',
        UPDATE = 'Indo Tax Reporting Setup:Purchaser ID Type:Update',
        DELETE = 'Indo Tax Reporting Setup:Purchaser ID Type:Delete',
      }

      export enum UnitOfMeasurement {
        VIEW = 'Indo Tax Reporting Setup:Unit of Measurement:View',
        ADD = 'Indo Tax Reporting Setup:Unit of Measurement:Add',
        UPDATE = 'Indo Tax Reporting Setup:Unit of Measurement:Update',
        DELETE = 'Indo Tax Reporting Setup:Unit of Measurement:Delete',
      }

      export enum CountryCode {
        VIEW = 'Indo Tax Reporting Setup:Country Code:View',
        ADD = 'Indo Tax Reporting Setup:Country Code:Add',
        UPDATE = 'Indo Tax Reporting Setup:Country Code:Update',
        DELETE = 'Indo Tax Reporting Setup:Country Code:Delete',
      }
    }

    export enum LeadChannel {
      ACTIVE_AND_DEACTIVE = 'Common Setting:Lead Channel:Active and Deactive',
      ADD = 'Common Setting:Lead Channel:Add',
      SET_DEFAULT = 'Common Setting:Lead Channel:Set Default',
      UPDATE = 'Common Setting:Lead Channel:Update',
      UPDATE_SEQUENCE = 'Common Setting:Lead Channel:Update sequence',
      VIEW = 'Common Setting:Lead Channel:View',
      DELETE = 'Common Setting:Lead Channel:Delete',
    }

    export enum Notary {
      ADD = 'Common Setting:Notary:Add',
      DELETE = 'Common Setting:Notary:Delete',
      UPDATE = 'Common Setting:Notary:Update',
      VIEW = 'Common Setting:Notary:View',
    }

    export enum PurchaserPaymentPlan {
      DELETE = 'Common Setting:Purchaser Payment Plan:Delete',
      ADD = 'Common Setting:Purchaser Payment Plan:Add',
      UPDATE = 'Common Setting:Purchaser Payment Plan:Update',
      VIEW = 'Common Setting:Purchaser Payment Plan:View',
    }

    export enum ReasonCode {
      VIEW = 'Common Setting:Reason Code:View',
    }

    export namespace ReasonCode {
      export enum CancellationReason {
        VIEW = 'Reason Code:Cancellation Reason:View',
        ADD = 'Reason Code:Cancellation Reason:Add',
        UPDATE = 'Reason Code:Cancellation Reason:Update',
        SET_DEFAULT = 'Reason Code:Cancellation Reason:Set Default',
        ACTIVE_AND_DEACTIVE = 'Reason Code:Cancellation Reason:Active and Deactive',
        UPDATE_SEQUENCE = 'Reason Code:Cancellation Reason:Update sequence',
        DELETE = 'Reason Code:Cancellation Reason:Delete',
      }

      export enum MarkupReason {
        VIEW = 'Reason Code:Markup Reason:View',
        ADD = 'Reason Code:Markup Reason:Add',
        UPDATE = 'Reason Code:Markup Reason:Update',
        SET_DEFAULT = 'Reason Code:Markup Reason:Set Default',
        ACTIVE_AND_DEACTIVE = 'Reason Code:Markup Reason:Active and Deactive',
        UPDATE_SEQUENCE = 'Reason Code:Markup Reason:Update sequence',
        DELETE = 'Reason Code:Markup Reason:Delete',
      }

      export enum PriceAdjustmentReason {
        VIEW = 'Reason Code:Price Adjustment Reason:View',
        ADD = 'Reason Code:Price Adjustment Reason:Add',
        UPDATE = 'Reason Code:Price Adjustment Reason:Update',
        SET_DEFAULT = 'Reason Code:Price Adjustment Reason:Set Default',
        ACTIVE_AND_DEACTIVE = 'Reason Code:Price Adjustment Reason:Active and Deactive',
        UPDATE_SEQUENCE = 'Reason Code:Price Adjustment Reason:Update sequence',
        DELETE = 'Reason Code:Price Adjustment Reason:Delete',
      }

      export enum UnitTransferReason {
        VIEW = 'Reason Code:Unit Transfer Reason:View',
        ADD = 'Reason Code:Unit Transfer Reason:Add',
        UPDATE = 'Reason Code:Unit Transfer Reason:Update',
        SET_DEFAULT = 'Reason Code:Unit Transfer Reason:Set Default',
        ACTIVE_AND_DEACTIVE = 'Reason Code:Unit Transfer Reason:Active and Deactive',
        UPDATE_SEQUENCE = 'Reason Code:Unit Transfer Reason:Update sequence',
        DELETE = 'Reason Code:Unit Transfer Reason:Delete',
      }
    }

    export enum StampDuty {
      ACTIVE_AND_DEACTIVE = 'Common Setting:Stamp Duty:Active and Deactive',
      ADD = 'Common Setting:Stamp Duty:Add',
      UPDATE = 'Common Setting:Stamp Duty:Update',
      VIEW = 'Common Setting:Stamp Duty:View',
    }

    export enum StandardApprovalFlow {
      VIEW = 'Common Setting:Standard Approval Flow:View',
    }

    export namespace StandardApprovalFlow {
      export enum SalesRegistration {
        VIEW = 'Standard Approval Flow:Sales Registration:View',
        UPDATE = 'Standard Approval Flow:Sales Registration:Update',
        DELETE = 'Standard Approval Flow:Sales Registration:Delete',
      }

      export enum SalesCancellation {
        VIEW = 'Standard Approval Flow:Sales Cancellation:View',
        UPDATE = 'Standard Approval Flow:Sales Cancellation:Update',
        DELETE = 'Standard Approval Flow:Sales Cancellation:Delete',
      }

      export enum LoanCancellation {
        VIEW = 'Standard Approval Flow:Loan Cancellation:View',
        UPDATE = 'Standard Approval Flow:Loan Cancellation:Update',
        DELETE = 'Standard Approval Flow:Loan Cancellation:Delete',
      }

      export enum UnitTransfer {
        VIEW = 'Standard Approval Flow:Unit Transfer:View',
        UPDATE = 'Standard Approval Flow:Unit Transfer:Update',
        DELETE = 'Standard Approval Flow:Unit Transfer:Delete',
      }

      export enum UnitPricing {
        VIEW = 'Standard Approval Flow:Unit Pricing:View',
        UPDATE = 'Standard Approval Flow:Unit Pricing:Update',
        DELETE = 'Standard Approval Flow:Unit Pricing:Delete',
      }

      export enum CreditNote {
        VIEW = 'Standard Approval Flow:Credit Note:View',
        UPDATE = 'Standard Approval Flow:Credit Note:Update',
        DELETE = 'Standard Approval Flow:Credit Note:Delete',
      }

      export enum Rebate {
        VIEW = 'Standard Approval Flow:Rebate:View',
        UPDATE = 'Standard Approval Flow:Rebate:Update',
        DELETE = 'Standard Approval Flow:Rebate:Delete',
      }

      export enum Contra {
        VIEW = 'Standard Approval Flow:Contra:View',
        UPDATE = 'Standard Approval Flow:Contra:Update',
        DELETE = 'Standard Approval Flow:Contra:Delete',
      }

      export enum Refund {
        VIEW = 'Standard Approval Flow:Refund:View',
        UPDATE = 'Standard Approval Flow:Refund:Update',
        DELETE = 'Standard Approval Flow:Refund:Delete',
      }
    }

    export enum StandardELetteringTemplate {
      VIEW = 'Common Setting:Standard E-Lettering Template:View',
    }

    export enum StandardParameter {
      VIEW = 'Common Setting:Standard Parameter:View',
    }

    export namespace StandardParameter {
      export enum PropertyType {
        VIEW = 'Standard Parameter:Property Type:View',
        ADD = 'Standard Parameter:Property Type:Add',
        UPDATE = 'Standard Parameter:Property Type:Update',
        SET_DEFAULT = 'Standard Parameter:Property Type:Set Default',
        ACTIVE_AND_DEACTIVE = 'Standard Parameter:Property Type:Active and Deactive',
        UPDATE_SEQUENCE = 'Standard Parameter:Property Type:Update sequence',
        DELETE = 'Standard Parameter:Property Type:Delete',
      }

      export enum ProjectType {
        VIEW = 'Standard Parameter:Project Type:View',
        ADD = 'Standard Parameter:Project Type:Add',
        UPDATE = 'Standard Parameter:Project Type:Update',
        SET_DEFAULT = 'Standard Parameter:Project Type:Set Default',
        ACTIVE_AND_DEACTIVE = 'Standard Parameter:Project Type:Active and Deactive',
        UPDATE_SEQUENCE = 'Standard Parameter:Project Type:Update sequence',
        DELETE = 'Standard Parameter:Project Type:Delete',
      }

      export enum UnitDirection {
        VIEW = 'Standard Parameter:Unit Direction:View',
        ADD = 'Standard Parameter:Unit Direction:Add',
        UPDATE = 'Standard Parameter:Unit Direction:Update',
        SET_DEFAULT = 'Standard Parameter:Unit Direction:Set Default',
        ACTIVE_AND_DEACTIVE = 'Standard Parameter:Unit Direction:Active and Deactive',
        UPDATE_SEQUENCE = 'Standard Parameter:Unit Direction:Update sequence',
        DELETE = 'Standard Parameter:Unit Direction:Delete',
      }

      export enum UnitType {
        VIEW = 'Standard Parameter:Unit Type:View',
        ADD = 'Standard Parameter:Unit Type:Add',
        UPDATE = 'Standard Parameter:Unit Type:Update',
        SET_DEFAULT = 'Standard Parameter:Unit Type:Set Default',
        ACTIVE_AND_DEACTIVE = 'Standard Parameter:Unit Type:Active and Deactive',
        UPDATE_SEQUENCE = 'Standard Parameter:Unit Type:Update sequence',
        DELETE = 'Standard Parameter:Unit Type:Delete',
      }

      export enum MaritalStatus {
        VIEW = 'Standard Parameter:Marital Status:View',
        ADD = 'Standard Parameter:Marital Status:Add',
        UPDATE = 'Standard Parameter:Marital Status:Update',
        SET_DEFAULT = 'Standard Parameter:Marital Status:Set Default',
        ACTIVE_AND_DEACTIVE = 'Standard Parameter:Marital Status:Active and Deactive',
        UPDATE_SEQUENCE = 'Standard Parameter:Marital Status:Update sequence',
        DELETE = 'Standard Parameter:Marital Status:Delete',
      }

      export enum Salutation {
        VIEW = 'Standard Parameter:Salutation:View',
        ADD = 'Standard Parameter:Salutation:Add',
        UPDATE = 'Standard Parameter:Salutation:Update',
        SET_DEFAULT = 'Standard Parameter:Salutation:Set Default',
        ACTIVE_AND_DEACTIVE = 'Standard Parameter:Salutation:Active and Deactive',
        UPDATE_SEQUENCE = 'Standard Parameter:Salutation:Update sequence',
        DELETE = 'Standard Parameter:Salutation:Delete',
      }

      export enum Religion {
        VIEW = 'Standard Parameter:Religion:View',
        ADD = 'Standard Parameter:Religion:Add',
        UPDATE = 'Standard Parameter:Religion:Update',
        SET_DEFAULT = 'Standard Parameter:Religion:Set Default',
        ACTIVE_AND_DEACTIVE = 'Standard Parameter:Religion:Active and Deactive',
        UPDATE_SEQUENCE = 'Standard Parameter:Religion:Update sequence',
        DELETE = 'Standard Parameter:Religion:Delete',
      }

      export enum Relationship {
        VIEW = 'Standard Parameter:Relationship:View',
        ADD = 'Standard Parameter:Relationship:Add',
        UPDATE = 'Standard Parameter:Relationship:Update',
        SET_DEFAULT = 'Standard Parameter:Relationship:Set Default',
        ACTIVE_AND_DEACTIVE = 'Standard Parameter:Relationship:Active and Deactive',
        UPDATE_SEQUENCE = 'Standard Parameter:Relationship:Update sequence',
        DELETE = 'Standard Parameter:Relationship:Delete',
      }

      export enum Education {
        VIEW = 'Standard Parameter:Education:View',
        ADD = 'Standard Parameter:Education:Add',
        UPDATE = 'Standard Parameter:Education:Update',
        SET_DEFAULT = 'Standard Parameter:Education:Set Default',
        ACTIVE_AND_DEACTIVE = 'Standard Parameter:Education:Active and Deactive',
        UPDATE_SEQUENCE = 'Standard Parameter:Education:Update sequence',
        DELETE = 'Standard Parameter:Education:Delete',
      }

      export enum Industry {
        VIEW = 'Standard Parameter:Industry:View',
        ADD = 'Standard Parameter:Industry:Add',
        UPDATE = 'Standard Parameter:Industry:Update',
        SET_DEFAULT = 'Standard Parameter:Industry:Set Default',
        ACTIVE_AND_DEACTIVE = 'Standard Parameter:Industry:Active and Deactive',
        UPDATE_SEQUENCE = 'Standard Parameter:Industry:Update sequence',
        DELETE = 'Standard Parameter:Industry:Delete',
      }

      export enum Designation {
        VIEW = 'Standard Parameter:Designation:View',
        ADD = 'Standard Parameter:Designation:Add',
        UPDATE = 'Standard Parameter:Designation:Update',
        SET_DEFAULT = 'Standard Parameter:Designation:Set Default',
        ACTIVE_AND_DEACTIVE = 'Standard Parameter:Designation:Active and Deactive',
        UPDATE_SEQUENCE = 'Standard Parameter:Designation:Update sequence',
        DELETE = 'Standard Parameter:Designation:Delete',
      }

      export enum Profession {
        VIEW = 'Standard Parameter:Profession:View',
        ADD = 'Standard Parameter:Profession:Add',
        UPDATE = 'Standard Parameter:Profession:Update',
        SET_DEFAULT = 'Standard Parameter:Profession:Set Default',
        ACTIVE_AND_DEACTIVE = 'Standard Parameter:Profession:Active and Deactive',
        UPDATE_SEQUENCE = 'Standard Parameter:Profession:Update sequence',
        DELETE = 'Standard Parameter:Profession:Delete',
      }

      export enum IncomeRange {
        VIEW = 'Standard Parameter:Income Range:View',
        ADD = 'Standard Parameter:Income Range:Add',
        UPDATE = 'Standard Parameter:Income Range:Update',
        SET_DEFAULT = 'Standard Parameter:Income Range:Set Default',
        ACTIVE_AND_DEACTIVE = 'Standard Parameter:Income Range:Active and Deactive',
        UPDATE_SEQUENCE = 'Standard Parameter:Income Range:Update sequence',
        DELETE = 'Standard Parameter:Income Range:Delete',
      }
    }

    export enum StatutoryDocumentsSetup {
      ADD = 'Common Setting:Statutory Documents Setup:Add',
      DELETE = 'Common Setting:Statutory Documents Setup:Delete',
      UPDATE = 'Common Setting:Statutory Documents Setup:Update',
      VIEW = 'Common Setting:Statutory Documents Setup:View',
    }

    export enum TaxScheme {
      ADD = 'Common Setting:Tax Scheme:Add',
      UPDATE = 'Common Setting:Tax Scheme:Update',
      VIEW = 'Common Setting:Tax Scheme:View',
      ACTIVE_AND_DEACTIVE = 'Common Setting:Tax Scheme:Active and Deactive',
      DELETE = 'Common Setting:Tax Scheme:Delete',
    }

    export enum TaxSetup {
      ACTIVE_AND_DEACTIVE = 'Common Setting:Tax Setup:Active and Deactive',
      ADD = 'Common Setting:Tax Setup:Add',
      UPDATE = 'Common Setting:Tax Setup:Update',
      VIEW = 'Common Setting:Tax Setup:View',
      DELETE = 'Common Setting:Tax Setup:Delete',
    }

    export enum TransactionType {
      DELETE = 'Common Setting:Transaction Type:Delete',
      ADD = 'Common Setting:Transaction Type:Add',
      UPDATE = 'Common Setting:Transaction Type:Update',
      VIEW = 'Common Setting:Transaction Type:View',
    }
  }

  export enum ProjectSetup {
    VIEW = 'Project Setup:View',
    ADD = 'Project Setup:Add',
  }

  export namespace ProjectSetup {
    export enum ProjectDetails {
      VIEW = 'Project Setup:Project Details:View',
      UPDATE = 'Project Setup:Project Details:Update',
    }

    export enum RoleAndAccessSecurity {
      VIEW = 'Project Setup:Role & Access Security:View',
      UPDATE = 'Project Setup:Role & Access Security:Update',
    }

    export enum ProjectSalesPolicy {
      VIEW = 'Project Setup:Project Sales Policy:View',
      UPDATE = 'Project Setup:Project Sales Policy:Update',
    }

    export enum ProjectClusterSetup {
      VIEW = 'Project Setup:Project Cluster Setup:View',
      ADD = 'Project Setup:Project Cluster Setup:Add',
      UPDATE = 'Project Setup:Project Cluster Setup:Update',
      DELETE = 'Project Setup:Project Cluster Setup:Delete',
    }

    export enum UnitSetup {
      VIEW = 'Project Setup:Unit Setup:View',
      ADD = 'Project Setup:Unit Setup:Add',
      UPDATE = 'Project Setup:Unit Setup:Update',
      DELETE = 'Project Setup:Unit Setup:Delete',
      IMPORT_UNIT_AND_CAR_PARK = 'Project Setup:Unit Setup:Import Unit & Car Park',
      IMPORT_UNIT = 'Project Setup:Unit Setup:Import Unit',
    }

    export enum CarParkSetup {
      VIEW = 'Project Setup:Car Park Setup:View',
      ADD = 'Project Setup:Car Park Setup:Add',
      UPDATE = 'Project Setup:Car Park Setup:Update',
      DELETE = 'Project Setup:Car Park Setup:Delete',
      IMPORT_UNIT_AND_CAR_PARK = 'Project Setup:Car Park Setup:Import Unit & Car Park',
      IMPORT_UNIT = 'Project Setup:Car Park Setup:Import Unit',
    }

    export enum UnitPricing {
      ADD = 'Project Setup:Unit Pricing:Add',
      VIEW = 'Project Setup:Unit Pricing:View',
      UPDATE = 'Project Setup:Unit Pricing:Update',
      DELETE = 'Project Setup:Unit Pricing:Delete',
      APPROVE_AND_REJECT = 'Project Setup:Unit Pricing:Approve and Reject',
    }

       export enum UnitPaymentPlan {
      VIEW = 'Project Setup:Purchaser Payment Plan:View',
      ADD = 'Project Setup:Purchaser Payment Plan:Add',
      ACTIVE_AND_DEACTIVE = 'Project Setup:Purchaser Payment Plan:Active and Deactive',
      SET_DEFAULT = 'Project Setup:Purchaser Payment Plan:Set Default',
      DELETE = 'Project Setup:Purchaser Payment Plan:Delete',
    }

    export enum UnitStatutoryDocumentRequirements {
      UPDATE = 'Project Setup:Unit Statutory Document Requirements:Update',
      VIEW = 'Project Setup:Unit Statutory Document Requirements:View',
    }

    export enum NotaryAssignment {
      UNASSIGN = 'Project Setup:Notary Assignment:Unassign',
      VIEW = 'Project Setup:Notary Assignment:View',
      ASSIGN = 'Project Setup:Notary Assignment:Assign',
    }

    export enum PromotionalItem {
      VIEW = 'Project Setup:Promotional Item:View',
      ADD = 'Project Setup:Promotional Item:Add',
      UPDATE = 'Project Setup:Promotional Item:Update',
      DELETE = 'Project Setup:Promotional Item:Delete',
    }

    export enum PromotionalPackages {
      ADD = 'Project Setup:Promotional Packages:Add',
      UPDATE = 'Project Setup:Promotional Packages:Update',
      DELETE = 'Project Setup:Promotional Packages:Delete',
      VIEW = 'Project Setup:Promotional Packages:View',
    }

    export namespace PromotionalPackages {
      export enum PromotionalPackagesDetail {
        VIEW = 'Promotional Packages:Promotional Packages Detail:View',
        DELETE = 'Promotional Packages:Promotional Packages Detail:Delete',
      }
    }

    export enum PurchaserPaymentPlan {
      VIEW = 'Project Setup:Purchaser Payment Plan:View',
      ADD = 'Project Setup:Purchaser Payment Plan:Add',
      ACTIVE_AND_DEACTIVE = 'Project Setup:Purchaser Payment Plan:Active and Deactive',
      SET_DEFAULT = 'Project Setup:Purchaser Payment Plan:Set Default',
      DELETE = 'Project Setup:Purchaser Payment Plan:Delete',
    }

    export enum Discount {
      VIEW = 'Project Setup:Discount:View',
      ADD = 'Project Setup:Discount:Add',
      UPDATE = 'Project Setup:Discount:Update',
      DELETE = 'Project Setup:Discount:Delete',
      SET_DEFAULT = 'Project Setup:Discount:Set Default',
    }

    export enum Campaign {
      VIEW = 'Project Setup:Campaign:View',
      ADD = 'Project Setup:Campaign:Add',
      UPDATE = 'Project Setup:Campaign:Update',
      ACTIVE_AND_DEACTIVE = 'Project Setup:Campaign:Active and Deactive',
      EVENT_LIST = 'Project Setup:Campaign:Event List',
      DELETE = 'Project Setup:Campaign:Delete',
    }

    export namespace Campaign {
      export enum CampaignEvent {
        ADD = 'Campaign:Campaign Event:Add',
        VIEW = 'Campaign:Campaign Event:View',
        UPDATE = 'Campaign:Campaign Event:Update',
        DELETE = 'Campaign:Campaign Event:Delete',
      }
    }

    export enum TeamAssignment {
      VIEW = 'Project Setup:Team Assignment:View',
      ADD = 'Project Setup:Team Assignment:Add',
      UPDATE = 'Project Setup:Team Assignment:Update',
      DELETE = 'Project Setup:Team Assignment:Delete',
      ASSIGN_TEAM_MEMBER = 'Project Setup:Team Assignment:Assign Team Member',
    }

    export namespace TeamAssignment {
      export enum TeamAssignmentAssignTeamMember {
        UNASSIGN = 'Team Assignment:Team Assignment Assign Team Member:Unassign',
        VIEW = 'Team Assignment:Team Assignment Assign Team Member:View',
        ASSIGN = 'Team Assignment:Team Assignment Assign Team Member:Assign',
      }
    }

    export enum ProjectReminderSetting {
      VIEW = 'Project Setup:Project Reminder Setting:View',
      UPDATE = 'Project Setup:Project Reminder Setting:Update',
    }

    export enum ProjectApprovalFlow {
      VIEW = 'Project Setup:Project Approval Flow:View',
    }

    export namespace ProjectApprovalFlow {
      export enum SalesCancellation {
        VIEW = 'Project Approval Flow:Sales Cancellation:View',
        UPDATE = 'Project Approval Flow:Sales Cancellation:Update',
        COPY_FORM = 'Project Approval Flow:Sales Cancellation:Copy Form',
      }

      export enum LoanCancellation {
        VIEW = 'Project Approval Flow:Loan Cancellation:View',
        UPDATE = 'Project Approval Flow:Loan Cancellation:Update',
        COPY_FORM = 'Project Approval Flow:Loan Cancellation:Copy Form',
      }

      export enum UnitTransfer {
        VIEW = 'Project Approval Flow:Unit Transfer:View',
        UPDATE = 'Project Approval Flow:Unit Transfer:Update',
        COPY_FORM = 'Project Approval Flow:Unit Transfer:Copy Form',
      }

      export enum UnitPricing {
        VIEW = 'Project Approval Flow:Unit Pricing:View',
        UPDATE = 'Project Approval Flow:Unit Pricing:Update',
        COPY_FORM = 'Project Approval Flow:Unit Pricing:Copy Form',
      }

      export enum CreditNote {
        VIEW = 'Project Approval Flow:Credit Note:View',
        UPDATE = 'Project Approval Flow:Credit Note:Update',
        COPY_FORM = 'Project Approval Flow:Credit Note:Copy Form',
      }

      export enum Rebate {
        VIEW = 'Project Approval Flow:Rebate:View',
        UPDATE = 'Project Approval Flow:Rebate:Update',
        COPY_FORM = 'Project Approval Flow:Rebate:Copy Form',
      }

      export enum Contra {
        VIEW = 'Project Approval Flow:Contra:View',
        UPDATE = 'Project Approval Flow:Contra:Update',
        COPY_FORM = 'Project Approval Flow:Contra:Copy Form',
      }

      export enum Refund {
        VIEW = 'Project Approval Flow:Refund:View',
        UPDATE = 'Project Approval Flow:Refund:Update',
        COPY_FORM = 'Project Approval Flow:Refund:Copy Form',
      }
    }

    export enum ProjectStandardLetter {
      VIEW = 'Project Setup:Project Standard Letter:View',
      ADD = 'Project Setup:Project Standard Letter:Add',
      UPDATE = 'Project Setup:Project Standard Letter:Update',
      DELETE = 'Project Setup:Project Standard Letter:Delete',
      DESIGN = 'Project Setup:Project Standard Letter:Design',
      CLONE = 'Project Setup:Project Standard Letter:Clone',
      SET_DEFAULT = 'Project Setup:Project Standard Letter:Set Default',
    }

    export enum StampDutyIntegrationSetup {
      VIEW = 'Project Setup:Stamp Duty Integration Setup:View',
      ADD = 'Project Setup:Stamp Duty Integration Setup:Add',
      UPDATE = 'Project Setup:Stamp Duty Integration Setup:Update',
      DELETE = 'Project Setup:Stamp Duty Integration Setup:Delete',
    }

    export enum SalesOfficeInfo {
      VIEW = 'Project Setup:Sales Office Info:View',
      UPDATE = 'Project Setup:Sales Office Info:Update',
    }

    export enum ConstructionInfo {
      VIEW = 'Project Setup:Construction Info:View',
      UPDATE = 'Project Setup:Construction Info:Update',
    }

    export enum FireInsuranceInfo {
      VIEW = 'Project Setup:Fire Insurance Info:View',
      UPDATE = 'Project Setup:Fire Insurance Info:Update',
    }

    export enum BusinessPermit {
      VIEW = 'Project Setup:Business Permit:View',
      ADD = 'Project Setup:Business Permit:Add',
      UPDATE = 'Project Setup:Business Permit:Update',
      DELETE = 'Project Setup:Business Permit:Delete',
    }
  }

  export enum Home {
    VIEW = 'Home:View',
  }

  export namespace Home {
    export enum NewsAnnouncementListing {
      VIEW = 'Home:News Announcement Listing:View',
    }

    export enum BookingConfirmation {
      VIEW = 'Home:Booking Confirmation:View',
    }

    export enum CalendarAndAppointment {
      VIEW = 'Home:Calendar and Appoinment:View',
      ADD = 'Home:Calendar and Appoinment:Add',
    }

    export enum NotificationListing {
      VIEW = 'Home:Notification Listing:View',
    }
  }

  export enum Notification {
    VIEW = 'Notification:View',
    UPDATE = 'Notification:Update',
  }

  export enum ProjectBussinessInsight {
    VIEW = 'Project Bussiness Insight:View',
  }

  export namespace ProjectBussinessInsight {
    export enum ProjectSalesPerformance {
      VIEW = 'Project Bussiness Insight:Project Sales Performance:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Project Sales Performance:Download Excel Report',
    }

    export enum LotStatusMovement {
      VIEW = 'Project Bussiness Insight:Lot Status Movement:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Lot Status Movement:Download Excel Report',
    }

    export enum SalesMovement {
      VIEW = 'Project Bussiness Insight:Sales Movement:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Sales Movement:Download Excel Report',
    }

    export enum SalesAnalysis {
      VIEW = 'Project Bussiness Insight:Sales Analysis:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Sales Analysis:Download Excel Report',
    }

    export enum SalesAnalysisByUnitType {
      VIEW = 'Project Bussiness Insight:Sales Analysis By Unit Type:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Sales Analysis By Unit Type:Download Excel Report',
    }

    export enum SalesTeamPerformance {
      VIEW = 'Project Bussiness Insight:Sales Team Performance:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Sales Team Performance:Download Excel Report',
    }

    export enum SalesDemographicAnalysis {
      VIEW = 'Project Bussiness Insight:Sales Demographic Analysis:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Sales Demographic Analysis:Download Excel Report',
    }

    export enum CampaignPerformance {
      VIEW = 'Project Bussiness Insight:Campaign Performance:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Campaign Performance:Download Excel Report',
    }

    export enum SalesLeadPerformance {
      VIEW = 'Project Bussiness Insight:Sales Lead Performance:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Sales Lead Performance:Download Excel Report',
    }

    export enum TrackingOfPaymentMethod {
      VIEW = 'Project Bussiness Insight:Tracking of Payment Method:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Tracking of Payment Method:Download Excel Report',
    }

    export enum BookingListAnalysis {
      VIEW = 'Project Bussiness Insight:Booking List Analysis:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Booking List Analysis:Download Excel Report',
    }

    export enum WaitingListAnalysis {
      VIEW = 'Project Bussiness Insight:Waiting List Analysis:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Waiting List Analysis:Download Excel Report',
    }

    export enum Loan {
      VIEW = 'Project Bussiness Insight:Loan:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Loan:Download Excel Report',
    }

    export enum OutstandingSP {
      VIEW = 'Project Bussiness Insight:Outstanding S&P:View',
      DOWNLOAD_EXCEL_REPORT = 'Project Bussiness Insight:Outstanding S&P:Download Excel Report',
    }
  }

  export enum SalesCommission {
    VIEW = 'Sales Commission:View',
  }

  export namespace SalesCommission {
    export enum EmployeeJobPosition {
      VIEW = 'Sales Commission:Employee Job Position:View',
    }

    export namespace EmployeeJobPosition {
      export enum EmployeeJobPosition {
        UPDATE = 'Employee Job Position:Employee Job Position:Update',
        VIEW = 'Employee Job Position:Employee Job Position:View',
        ASSIGN = 'Employee Job Position:Employee Job Position:Assign',
      }

      export enum JobPosition {
        VIEW = 'Employee Job Position:Job Position:View',
        ADD = 'Employee Job Position:Job Position:Add',
        UPDATE = 'Employee Job Position:Job Position:Update',
        DELETE = 'Employee Job Position:Job Position:Delete',
      }
    }

    export enum CommissionType {
      VIEW = 'Sales Commission:Commission Type:View',
      ADD = 'Sales Commission:Commission Type:Add',
      UPDATE = 'Sales Commission:Commission Type:Update',
      DELETE = 'Sales Commission:Commission Type:Delete',
    }

    export enum CompanyReward {
      VIEW = 'Sales Commission:Company Reward:View',
      ADD = 'Sales Commission:Company Reward:Add',
      UPDATE = 'Sales Commission:Company Reward:Update',
      DELETE = 'Sales Commission:Company Reward:Delete',
    }

    export namespace CompanyReward {
      export enum CommissionPayment {
        VIEW = 'Company Reward:Commission Payment:View',
        ADD = 'Company Reward:Commission Payment:Add',
        UPDATE = 'Company Reward:Commission Payment:Update',
        DELETE = 'Company Reward:Commission Payment:Delete',
      }

      export namespace CommissionPayment {
        export enum RequiredStatutoryDocumentCompanyReward {
          VIEW = 'Commission Payment:Required Statutory Document Company Reward:View',
          ADD = 'Commission Payment:Required Statutory Document Company Reward:Add',
          UPDATE = 'Commission Payment:Required Statutory Document Company Reward:Update',
          DELETE = 'Commission Payment:Required Statutory Document Company Reward:Delete',
        }
      }
    }

    export enum ProjectCommission {
      VIEW = 'Sales Commission:Project Commission:View',
      ADD = 'Sales Commission:Project Commission:Add',
      UPDATE = 'Sales Commission:Project Commission:Update',
      DELETE = 'Sales Commission:Project Commission:Delete',
    }

    export namespace ProjectCommission {
      export enum CommissionPayment {
        VIEW = 'Project Commission:Commission Payment:View',
        ADD = 'Project Commission:Commission Payment:Add',
        UPDATE = 'Project Commission:Commission Payment:Update',
        DELETE = 'Project Commission:Commission Payment:Delete',
      }

      export namespace CommissionPayment {
        export enum RequiredStatutoryDocumentProjectCommission {
          VIEW = 'Commission Payment:Required Statutory Document Project Commission:View',
          ADD = 'Commission Payment:Required Statutory Document Project Commission:Add',
          UPDATE = 'Commission Payment:Required Statutory Document Project Commission:Update',
          DELETE = 'Commission Payment:Required Statutory Document Project Commission:Delete',
        }
      }
    }

    export enum CompanyCommissionTeamStructure {
      VIEW = 'Sales Commission:Company Commission Team Structure:View',
      ADD = 'Sales Commission:Company Commission Team Structure:Add',
      ADD_TEAM = 'Sales Commission:Company Commission Team Structure:Add Team',
      ADD_SUB = 'Sales Commission:Company Commission Team Structure:Add Sub',
      UPDATE_SUB = 'Sales Commission:Company Commission Team Structure:Update Sub',
      DELETE_SUB = 'Sales Commission:Company Commission Team Structure:Delete Sub',
    }

    export enum CompanyCommissionPackageAndTarget {
      VIEW = 'Sales Commission:Company Commission Package and Target:View',
      ADD = 'Sales Commission:Company Commission Package and Target:Add',
      UPDATE_SUB = 'Sales Commission:Company Commission Package and Target:Update Sub',
      DELETE_SUB = 'Sales Commission:Company Commission Package and Target:Delete Sub',
      ADD_SUB = 'Sales Commission:Company Commission Package and Target:Add Sub',
    }

    export enum ProjectCommissionPackageAndTarget {
      VIEW = 'Sales Commission:Project Commission Package and Target:View',
      ADD = 'Sales Commission:Project Commission Package and Target:Add',
      UPDATE_SUB = 'Sales Commission:Project Commission Package and Target:Update Sub',
      DELETE_SUB = 'Sales Commission:Project Commission Package and Target:Delete Sub',
      ADD_SUB = 'Sales Commission:Project Commission Package and Target:Add Sub',
    }

    export enum CommissionCalculation {
      VIEW = 'Sales Commission:Commission Calculation:View',
      ADD = 'Sales Commission:Commission Calculation:Add',
      UPDATE = 'Sales Commission:Commission Calculation:Update',
      CONFIRM = 'Sales Commission:Commission Calculation:Confirm',
    }

    export enum DigitalReport {
      VIEW = 'Sales Commission:Digital Report:View',
    }
  }

  export enum SalesAdmin {
    VIEW = 'Sales Admin:View',
  }

  export namespace SalesAdmin {
    export enum NUP {
      VIEW = 'Sales Admin:NUP:View',
      APPROVE_AND_REJECT = 'Sales Admin:NUP:Approve and Reject',
    }

    export enum UnitBooking {
      ADD = 'Sales Admin:Unit Booking:Add',
      VIEW = 'Sales Admin:Unit Booking:View',
      BOOKING_FEE = 'Sales Admin:Unit Booking:Booking Fee',
    }

    export namespace UnitBooking {
      export enum BookingFee {
        ADD = 'Unit Booking:Booking Fee Unit Booking:Add',
        VIEW = 'Unit Booking:Booking Fee Unit Booking:View',
        PRINT_FORM = 'Unit Booking:Booking Fee Unit Booking:Print Form',
        UPDATE = 'Unit Booking:Booking Fee Unit Booking:Update',
        APPROVE_AND_REJECT = 'Unit Booking:Booking Fee Unit Booking:Approve and Reject',
      }
    }

    export enum SalesRegistrations {
      ADD = 'Sales Admin:Sales Registrations:Add',
      UPDATE = 'Sales Admin:Sales Registrations:Update',
      VIEW = 'Sales Admin:Sales Registrations:View',
      PRINT = 'Sales Admin:Sales Registrations:Print',
      REVISE_REJECT_AND_APPROVE = 'Sales Admin:Sales Registrations:Revise Reject and Approve',
    }

    export namespace SalesRegistrations {
      export enum PurchaserInfo {
        VIEW = 'Sales Registrations:Purchaser Info:View',
        ADD = 'Sales Registrations:Purchaser Info:Add',
        UPDATE = 'Sales Registrations:Purchaser Info:Update',
        DELETE = 'Sales Registrations:Purchaser Info:Delete',
      }

      export enum UnitPrice {
        VIEW = 'Sales Registrations:Unit Price:View'
      }

      export enum CarparkInstallment {
        VIEW = 'Sales Registrations:Carpark Installment:View',
        ADD = 'Sales Registrations:Carpark Installment:Add',
        UPDATE = 'Sales Registrations:Carpark Installment:Update',
        DELETE = 'Sales Registrations:Carpark Installment:Delete',
      }

      export enum Package {
        VIEW = 'Sales Registrations:Package:View',
        ADD = 'Sales Registrations:Package:Add',
        UPDATE = 'Sales Registrations:Package:Update',
        DELETE = 'Sales Registrations:Package:Delete',
      }

      export enum Others {
        VIEW = 'Sales Registrations:Others:View',
        UPDATE = 'Sales Registrations:Others:Update',
      }

      export enum ContactPerson {
        VIEW = 'Sales Registrations:Contact Person:View',
        ADD = 'Sales Registrations:Contact Person:Add',
        UPDATE = 'Sales Registrations:Contact Person:Update',
        DELETE = 'Sales Registrations:Contact Person:Delete',
      }

      export enum PaymentPlan {
        UPDATE = 'Sales Registrations:Payment Plan:Update',
        VIEW = 'Sales Registrations:Payment Plan:View',
        INSTALLMENT_SCHEDULE = 'Sales Registrations:Payment Plan:Installment Schedule',
      }

      export enum Discount {
        VIEW = 'Sales Registrations:Discount:View',
        ADD = 'Sales Registrations:Discount:Add',
        UPDATE = 'Sales Registrations:Discount:Update',
        DELETE = 'Sales Registrations:Discount:Delete',
      }
    }

    export enum SalesCancellation {
      ADD = 'Sales Admin:Sales Cancellation:Add',
      UPDATE = 'Sales Admin:Sales Cancellation:Update',
      PRINT_FORM = 'Sales Admin:Sales Cancellation:Print Form',
      COMPLETED = 'Sales Admin:Sales Cancellation:Completed',
      CANCEL = 'Sales Admin:Sales Cancellation:Cancel',
      DETAIL = 'Sales Admin:Sales Cancellation:Detail',
    }

    export enum LandDeposit {
      DETAIL = 'Sales Admin:Land Deposit:Detail',
      ADD = 'Sales Admin:Land Deposit:Add',
      VIEW = 'Sales Admin:Land Deposit:View',
    }

    export enum EndFinancing {
      VIEW = 'Sales Admin:End Financing:View',
    }

    export namespace EndFinancing {
      export enum LoanApproval {
        DETAIL = 'End Financing:Loan Approval:Detail',
        APPROVE_AND_REJECT = 'End Financing:Loan Approval:Approve and Reject',
        ADD = 'End Financing:Loan Approval:Add',
        VIEW = 'End Financing:Loan Approval:View',
      }

      export enum LoanDifferential {
        DETAIL = 'End Financing:Loan Differential:Detail',
        RESCHEDULE = 'End Financing:Loan Differential:Reschedule',
        VIEW = 'End Financing:Loan Differential:View',
      }

      export enum LoanReleaseNotification {
        ADD = 'End Financing:Loan Release Notification:Add',
        UPDATE = 'End Financing:Loan Release Notification:Update',
        DELETE = 'End Financing:Loan Release Notification:Delete',
        DETAIL = 'End Financing:Loan Release Notification:Detail',
        APPROVE_AND_REJECT = 'End Financing:Loan Release Notification:Approve and Reject',
        EMAIL = 'End Financing:Loan Release Notification:Email',
        PRINT_LETTER = 'End Financing:Loan Release Notification:Print Letter',
        VIEW = 'End Financing:Loan Release Notification:View',
      }

      export enum LoanPayment {
        ADD = 'End Financing:Loan Payment:Add',
        UPDATE = 'End Financing:Loan Payment:Update',
        DELETE = 'End Financing:Loan Payment:Delete',
        VIEW = 'End Financing:Loan Payment:View',
      }

      export enum Refinancing {
        ADD = 'End Financing:Refinancing:Add',
        UPDATE = 'End Financing:Refinancing:Update',
        DELETE = 'End Financing:Refinancing:Delete',
        DETAIL = 'End Financing:Refinancing:Detail',
        REVISE_AND_REJECT = 'End Financing:Refinancing:Revise and Reject',
        VIEW = 'End Financing:Refinancing:View',
      }

      export enum BuyBack {
        ADD = 'End Financing:Buy Back:Add',
        UPDATE = 'End Financing:Buy Back:Update',
        DELETE = 'End Financing:Buy Back:Delete',
        DETAIL = 'End Financing:Buy Back:Detail',
        REVISE_AND_REJECT = 'End Financing:Buy Back:Revise and Reject',
        VIEW = 'End Financing:Buy Back:View',
      }
    }

    export enum PaymentSchedules {
      VIEW = 'Sales Admin:Payment Schedules:View',
    }

    export namespace PaymentSchedules {
      export enum RescheduleInstallment {
        ADD = 'Payment Schedules:Reschedule Installment:Add',
        VIEW = 'Payment Schedules:Reschedule Installment:View',
        DETAIL = 'Payment Schedules:Reschedule Installment:Detail',
      }

      export enum RescheduleInstallmentApproval {
        DETAIL = 'Payment Schedules:Reschedule Installment Approval:Detail',
        APPROVED_AND_REJECT = 'Payment Schedules:Reschedule Installment Approval:Approved and Reject',
        VIEW = 'Payment Schedules:Reschedule Installment Approval:View',
      }

      export enum PurchaserPaymentSchedule {
        VIEW = 'Payment Schedules:Purchaser Payment Schedule:View',
      }
    }

    export enum PurchaserAccounts {
      VIEW = 'Sales Admin:Purchaser Accounts:View',
    }

    export namespace PurchaserAccounts {
      export enum PurchaserLedger {
        VIEW = 'Purchaser Accounts:Purchaser Ledger:View',
      }

      export namespace PurchaserLedger {
        export enum PurchaserInstallment {
          DETAIL = 'Purchaser Ledger:Purchaser Installment:Detail',
          VIEW = 'Purchaser Ledger:Purchaser Installment:View',
        }

        export enum CarparkInstallment {
          DETAIL = 'Purchaser Ledger:Carpark Installment:Detail',
          VIEW = 'Purchaser Ledger:Carpark Installment:View',
        }

        export enum AdditionalPackage {
          VIEW = 'Purchaser Ledger:Additional Package:View',
          DETAIL = 'Purchaser Ledger:Additional Package:Detail',
        }

        export enum MiscBilling {
          VIEW = 'Purchaser Ledger:Misc Billing:View',
          ADD = 'Purchaser Ledger:Misc Billing:Add',
          APPROVE_AND_REJECT = 'Purchaser Ledger:Misc Billing:Approve and Reject',
          UPDATE = 'Purchaser Ledger:Misc Billing:Update',
        }

        export enum LateInterest {
          VIEW = 'Purchaser Ledger:Late Interest:View',
          UPDATE = 'Purchaser Ledger:Late Interest:Update',
          ADD = 'Purchaser Ledger:Late Interest:Add',
          APPROVE_AND_REJECT = 'Purchaser Ledger:Late Interest:Approve and Reject',
        }

        export enum DebitNote {
          VIEW = 'Purchaser Ledger:Debit Note:View',
          UPDATE = 'Purchaser Ledger:Debit Note:Update',
          ADD = 'Purchaser Ledger:Debit Note:Add',
          APPROVE_AND_REJECT = 'Purchaser Ledger:Debit Note:Approve and Reject',
        }

        export enum Payment {
          VIEW = 'Purchaser Ledger:Payment:View',
          ADD = 'Purchaser Ledger:Payment:Add',
          APPROVE_AND_REJECT = 'Purchaser Ledger:Payment:Approve and Reject',
          UPDATE = 'Purchaser Ledger:Payment:Update',
          ALLOCATION = 'Purchaser Ledger:Payment:Allocation',
          PRINT = 'Purchaser Ledger:Payment:Print',
        }

        export enum Rebate {
          VIEW = 'Purchaser Ledger:Rebate:View',
          UPDATE = 'Purchaser Ledger:Rebate:Update',
          ADD = 'Purchaser Ledger:Rebate:Add',
          APPROVE_AND_REJECT = 'Purchaser Ledger:Rebate:Approve and Reject',
        }

        export enum Deposit {
          VIEW = 'Purchaser Ledger:Deposit:View',
          ADD = 'Purchaser Ledger:Deposit:Add',
          APPROVE_AND_REVISE = 'Purchaser Ledger:Deposit:Approve and Revise',
          UPDATE = 'Purchaser Ledger:Deposit:Update',
          CONVERT_TO_PAYMENT = 'Purchaser Ledger:Deposit:Convert to Payment',
        }

        export enum Contra {
          VIEW = 'Purchaser Ledger:Contra:View',
          ALLOCATION = 'Purchaser Ledger:Contra:Allocation',
        }

        export enum Refund {
          VIEW = 'Purchaser Ledger:Refund:View',
          ADD = 'Purchaser Ledger:Refund:Add',
          APPROVE_AND_REVISE = 'Purchaser Ledger:Refund:Approve and Revise',
          UPDATE = 'Purchaser Ledger:Refund:Update',
        }

        export enum CreditNote {
          VIEW = 'Purchaser Ledger:Credit Note:View',
          UPDATE = 'Purchaser Ledger:Credit Note:Update',
          ADD = 'Purchaser Ledger:Credit Note:Add',
          APPROVE_AND_REJECT = 'Purchaser Ledger:Credit Note:Approve and Reject',
        }
      }

      export enum PurchaserInstallment {
        VIEW = 'Purchaser Accounts:Purchaser Installment:View',
        DETAIL = 'Purchaser Accounts:Purchaser Installment:Detail',
      }

      export enum AdditionalPackagesInstallment {
        VIEW = 'Purchaser Accounts:Additional Packages Installment:View',
        DETAIL = 'Purchaser Accounts:Additional Packages Installment:Detail',
      }

      export enum CarparkInstallment {
        VIEW = 'Purchaser Accounts:Carpark Installment:View',
        DETAIL = 'Purchaser Accounts:Carpark Installment:Detail',
      }

      export enum MiscBilling {
        VIEW = 'Purchaser Accounts:Misc Billing:View',
        ADD = 'Purchaser Accounts:Misc Billing:Add',
        APPROVE_AND_REJECT = 'Purchaser Accounts:Misc Billing:Approve and Reject',
        UPDATE = 'Purchaser Accounts:Misc Billing:Update',
      }

      export enum LateInterest {
        VIEW = 'Purchaser Accounts:Late Interest:View',
        DETAIL = 'Purchaser Accounts:Late Interest:Detail',
      }

      export enum Deposit {
        VIEW = 'Purchaser Accounts:Deposit:View',
        ADD = 'Purchaser Accounts:Deposit:Add',
        APPROVE_AND_REJECT = 'Purchaser Accounts:Deposit:Approve and Reject',
        UPDATE = 'Purchaser Accounts:Deposit:Update',
        CONVERT_TO_PAYMENT = 'Purchaser Accounts:Deposit:Convert to Payment',
      }

      export enum DebitNote {
        VIEW = 'Purchaser Accounts:Debit Note:View',
        UPDATE = 'Purchaser Accounts:Debit Note:Update',
        ADD = 'Purchaser Accounts:Debit Note:Add',
        APPROVE_AND_REJECT = 'Purchaser Accounts:Debit Note:Approve and Reject',
      }

      export enum CreditNote {
        VIEW = 'Purchaser Accounts:Credit Note:View',
        UPDATE = 'Purchaser Accounts:Credit Note:Update',
        ADD = 'Purchaser Accounts:Credit Note:Add',
        APPROVE_AND_REJECT = 'Purchaser Accounts:Credit Note:Approve and Reject',
      }

      export enum Rebate {
        VIEW = 'Purchaser Accounts:Rebate:View',
        UPDATE = 'Purchaser Accounts:Rebate:Update',
        ADD = 'Purchaser Accounts:Rebate:Add',
        APPROVE_AND_REJECT = 'Purchaser Accounts:Rebate:Approve and Reject',
      }

      export enum Payment {
        VIEW = 'Purchaser Accounts:Payment:View',
        ADD = 'Purchaser Accounts:Payment:Add',
        APPROVE_AND_REJECT = 'Purchaser Accounts:Payment:Approve and Reject',
        UPDATE = 'Purchaser Accounts:Payment:Update',
        PRINT = 'Purchaser Accounts:Payment:Print',
        ALLOCATION = 'Purchaser Accounts:Payment:Allocation',
      }

      export enum Contra {
        VIEW = 'Purchaser Accounts:Contra:View',
        ALLOCATION = 'Purchaser Accounts:Contra:Allocation',
      }

      export enum Refund {
        VIEW = 'Purchaser Accounts:Refund:View',
        ADD = 'Purchaser Accounts:Refund:Add',
        APPROVE_AND_REJECT = 'Purchaser Accounts:Refund:Approve and Reject',
        UPDATE = 'Purchaser Accounts:Refund:Update',
      }
    }

    export enum StatutoryDocuments {
      VIEW = 'Sales Admin:Statutory Documents:View',
      UPDATE = 'Sales Admin:Statutory Documents:Update',
      DELETE = 'Sales Admin:Statutory Documents:Delete',
      DOWNLOAD = 'Sales Admin:Statutory Documents:Download',
      UPLOAD = 'Sales Admin:Statutory Documents:Uploads',
    }

    export enum PurchaserNameTransfer {
      VIEW = 'Sales Admin:Purchaser Name Transfer:View',
      ADD = 'Sales Admin:Purchaser Name Transfer:Add',
      UPDATE = 'Sales Admin:Purchaser Name Transfer:Update',
      CONFIRM = 'Sales Admin:Purchaser Name Transfer:Confirm',
      PRINT_FORM = 'Sales Admin:Purchaser Name Transfer:Print Form',
      CANCEL = 'Sales Admin:Purchaser Name Transfer:Cancel',
    }

    export enum UnitTransfer {
      VIEW = 'Sales Admin:Unit Transfer:View',
      ADD = 'Sales Admin:Unit Transfer:Add',
      UPDATE = 'Sales Admin:Unit Transfer:Update',
      APPROVE = 'Sales Admin:Unit Transfer:Approve',
    }

    export enum CreditControl {
      VIEW = 'Sales Admin:Credit Control:View',
    }

    export namespace CreditControl {
      export enum OverduePurchaserAccount {
        VIEW = 'Credit Control:Overdue Purchaser Account:View',
        ASSIGN = 'Credit Control:Overdue Purchaser Account:Assign',
        RE_ASSIGN = 'Credit Control:Overdue Purchaser Account:Re-Assign',
      }

      export enum CollectionActivity {
        VIEW = 'Credit Control:Collection Activity:View',
      }

      export namespace CollectionActivity {
        export enum CollectionActivityDetail {
          VIEW = 'Collection Activity:Collection Activity Detail:View',
          ADD = 'Collection Activity:Collection Activity Detail:Add',
          UPDATE_ACTIVITY = 'Collection Activity:Collection Activity Detail:Update Activity',
          RESCHEDULE_ACTIVITY = 'Collection Activity:Collection Activity Detail:Reschedule Activity',
        }
      }

      export enum PaymentReminders {
        VIEW = 'Credit Control:Payment Reminders:View',
      }

      export namespace PaymentReminders {
        export enum PaymentReminderException {
          VIEW = 'Payment Reminders:Payment Reminder Exception:View',
          ADD = 'Payment Reminders:Payment Reminder Exception:Add',
          UPDATE = 'Payment Reminders:Payment Reminder Exception:Update',
          DELETE = 'Payment Reminders:Payment Reminder Exception:Delete',
        }

        export enum PaymentReminderGeneration {
          ADD = 'Payment Reminders:Payment Reminder Generation:Add',
          VIEW = 'Payment Reminders:Payment Reminder Generation:View',
          PRINT = 'Payment Reminders:Payment Reminder Generation:Print',
          EMAIL = 'Payment Reminders:Payment Reminder Generation:Email',
        }
      }

      export enum LatePaymentInterestException {
        VIEW = 'Credit Control:Late Payment Interest Exception:View',
        ADD = 'Credit Control:Late Payment Interest Exception:Add',
        UPDATE = 'Credit Control:Late Payment Interest Exception:Update',
        DELETE = 'Credit Control:Late Payment Interest Exception:Delete',
      }

      export enum CollectionStaff {
        ASSIGN = 'Credit Control:Collection Staff:Assign',
        VIEW = 'Credit Control:Collection Staff:View',
        UNASSIGN = 'Credit Control:Collection Staff:Unassign',
      }
    }

    export enum Stakeholder {
      VIEW = 'Sales Admin:Stakeholder:View',
    }

    export namespace Stakeholder {
      export enum StakeholderUnitSummary {
        VIEW = 'Stakeholder:Stakeholder Unit Summary:View',
        UPDATE = 'Stakeholder:Stakeholder Unit Summary:Update',
      }

      export enum DeemCollected {
        ADD = 'Stakeholder:Deem Collected:Add',
        VIEW = 'Stakeholder:Deem Collected:View',
        UPDATE = 'Stakeholder:Deem Collected:Update',
        DELETE = 'Stakeholder:Deem Collected:Delete',
        POST = 'Stakeholder:Deem Collected:Post',
        REVERSAL = 'Stakeholder:Deem Collected:Reversal',
      }

      export enum StakeholderRelease {
        ADD = 'Stakeholder:Stakeholder Release:Add',
        VIEW = 'Stakeholder:Stakeholder Release:View',
        UPDATE = 'Stakeholder:Stakeholder Release:Update',
        DELETE = 'Stakeholder:Stakeholder Release:Delete',
        POST = 'Stakeholder:Stakeholder Release:Post',
        REVERSAL = 'Stakeholder:Stakeholder Release:Reversal',
      }
    }

    export enum VacantPossession {
      ADD = 'Sales Admin:Vacant Possession:Add',
      VIEW = 'Sales Admin:Vacant Possession:View',
      SHARE = 'Sales Admin:Vacant Possession:Share',
    }

    export enum PropertyTitle {
      VIEW = 'Sales Admin:Property Title:View',
      ADD = 'Sales Admin:Property Title:Add',
      UPDATE = 'Sales Admin:Property Title:Update',
      DELETE = 'Sales Admin:Property Title:Delete',
    }

    export enum AreaVariance {
      VIEW = 'Sales Admin:Area Variance:View',
    }

    export namespace AreaVariance {
      export enum AreaVariancePolicy {
        VIEW = 'Area Variance:Area Variance Policy:View',
        ADD = 'Area Variance:Area Variance Policy:Add',
        UPDATE = 'Area Variance:Area Variance Policy:Update',
        DELETE = 'Area Variance:Area Variance Policy:Delete',
      }

      export enum AreaVariance {
        VIEW = 'Area Variance:Area Variance:View',
        ADD = 'Area Variance:Area Variance:Add',
        UPDATE = 'Area Variance:Area Variance:Update',
        COMPLETED = 'Area Variance:Area Variance:Completed',
        PRINT_FORM = 'Area Variance:Area Variance:Print Form',
        CANCEL = 'Area Variance:Area Variance:Cancel',
        REVERSAL = 'Area Variance:Area Variance:Reversal',
        SHARE = 'Area Variance:Area Variance:Share',
      }
    }

    export enum LiquidatedAscertainedDamages {
      VIEW = 'Sales Admin:Liquidated Ascertained Damages:View',
    }

    export namespace LiquidatedAscertainedDamages {
      export enum LiquidatedAscertainedDamagesSetting {
        VIEW = 'Liquidated Ascertained Damages:Liquidated Ascertained Damages Setting:View',
        UPDATE = 'Liquidated Ascertained Damages:Liquidated Ascertained Damages Setting:Update',
      }

      export enum LiquidatedAscertainedDamagesProcessing {
        ADD = 'Liquidated Ascertained Damages:Liquidated Ascertained Damages Processing:Add',
        SIMULATED = 'Liquidated Ascertained Damages:Liquidated Ascertained Damages Processing:Simulated',
        POSTED = 'Liquidated Ascertained Damages:Liquidated Ascertained Damages Processing:Posted',
      }
    }

    export enum DigitalReports {
      VIEW = 'Sales Admin:Digital Reports:View',
    }
  }

  export enum SalesCRM {
    VIEW = 'Sales CRM:View',
  }

  export enum DigitalReports {
    VIEW = 'Digital Reports:View',
  }

  export enum SystemAdmin {
    VIEW = 'System Admin:View',
  }

  export enum AIAssistant {
    VIEW = 'AI Assistant:View',
  }
}

export const defaultPermission = [
  ...Object.values(Permission.Profile),
  Permission.Logout.VIEW,
  Permission.AIAssistant.VIEW,
]
